import { render, staticRenderFns } from "./integral_goods.vue?vue&type=template&id=5742f07a"
import script from "./integral_goods.vue?vue&type=script&lang=ts"
export * from "./integral_goods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports